<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      line-form
      show-save-button
      unit="颜色"
      edit-title
      id-key="ColorId"
      :data="data"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @opened="$refs.typeSelect.init()"
      @closed="$refs.typeSelect.clear()"
      :form-rules="rules"
      :save-func="api.save"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="颜色类别" prop="ClassId">
          <type-select ref="typeSelect" v-model="data.ClassId" />
        </el-form-item>
        <el-form-item label="颜色编码" prop="ColorNo">
          <el-input v-model="data.ColorNo" placeholder="请输入颜色编码" />
        </el-form-item>
        <el-form-item label="颜色名称" prop="ColorName">
          <el-input v-model="data.ColorName" placeholder="请输入颜色名称" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import typeSelect from './type/select'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect
  },
  data() {
    return {
      data: {
        ColorId: 0,
        ColorName: '',
        ColorNo: '',
        ClassId: null,
        ClassName: '',
        Status: 1,
        Sn: 0
      },
      api: require('@/api/ba/color').default,
      rules: {
         ColorNo: [{ required: true, message: '颜色编码不能为空' }],
        ColorName: [{ required: true, message: '颜色名称不能为空' }],
        ClassId: [{ required: true, message: '请选择颜色类别' }],
        Sn: [{ required: true, message: '序号不能为空' }]
      }
    }
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxSn(this.data.ClassId || 0).then(res => {
        this.data.Sn = res
      })
    },
    onEditOpened(data) {}
  }
}
</script>